import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import { addToCart, removeFromCart } from "@utils/reduxToolkit/features/cartSlice";
import Image from "next/legacy/image";
import { useEffect, useState } from "react";
import useCollapse from "react-collapsed";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import theme from "src/globalModule/styles/theme";
import classes from "../../styles/pujaRegistrationBhet.module.css";
import { trackEvent } from "@utils/analytics/event-analytics";
import { WEB_ENGAGE } from "@utils/constants";
function PujaBhetCard({
  data,
  subEventDetails,
  eventid,
  subeventid
}) {
  const {
    t
  } = useTranslation();
  const bigScreen = useMediaQuery("(min-width:768px)");
  const [bhetCardDescription, setBhetCardDescription] = useState("");
  const [showMoreBtn, setShowMoreBtn] = useState(false);
  const {
    getCollapseProps,
    getToggleProps
  } = useCollapse({
    collapsedHeight: 20
  });
  const dispatch = useDispatch();
  const {
    cart
  } = useSelector(state => state.cart);
  const existInCart = cart.find(item => item.subEventID === data.subEventID);
  useEffect(() => {
    if (data?.description) {
      if (bigScreen ? data?.description.length > 60 : data?.description.length > 30) {
        setShowMoreBtn(true);
      }
      setBhetCardDescription(data?.description);
    }
  }, [data]);
  return <Box className={classes.bhetContainer} data-sentry-element="Box" data-sentry-component="PujaBhetCard" data-sentry-source-file="pujaBhetCard.jsx">
      <Stack direction={"column"} display={"flex"} flexGrow={1} mt={"5px"} data-sentry-element="Stack" data-sentry-source-file="pujaBhetCard.jsx">
        <Typography sx={{
        fontFamily: "Poppins",
        color: theme.palette.text.primaryHead
      }} className={classes.ellipsisHeader} data-sentry-element="Typography" data-sentry-source-file="pujaBhetCard.jsx">
          {data?.name}
        </Typography>

        <div {...getToggleProps()}>
          {showMoreBtn ? <Typography mt={"2px"} sx={{
          color: theme.palette.text.secondaryDark,
          fontSize: "15px",
          whiteSpace: "pre-line"
        }} {...getCollapseProps()}>
              {bhetCardDescription}
            </Typography> : <Typography mt={"2px"} sx={{
          color: theme.palette.text.secondaryDark,
          fontSize: "15px",
          whiteSpace: "pre-line"
        }}>
              {bhetCardDescription}
            </Typography>}
        </div>

        <Stack direction={"row"} mt={"10px"} alignItems={"center"} spacing={1} data-sentry-element="Stack" data-sentry-source-file="pujaBhetCard.jsx">
          <Typography fontFamily={"Poppins"} fontSize={"15px"} fontWeight={"bold"} sx={{
          color: theme.palette.text.primaryHead
        }} data-sentry-element="Typography" data-sentry-source-file="pujaBhetCard.jsx">
            ₹ {data?.eventRegistrationAmount}/-
          </Typography>

          {data?.isMostOffered && <Box className={classes.border}>
              <Typography fontSize={"12px"} fontWeight={"600"} className={classes.mostOffered}>
                {t("most-offered")}{" "}
              </Typography>
            </Box>}
        </Stack>
      </Stack>

      <div className={classes.bhetRightContainer}>
        <div className={classes.bhetImageContainer}>
          <Image src={data?.images[0]} alt={data?.name} height={100} width={120} className={classes.bhetImage} data-sentry-element="Image" data-sentry-source-file="pujaBhetCard.jsx" />
        </div>

        {!existInCart ?
      // + ADD
      <Stack height={"32px"} width={"100px"} direction={"row"} className={classes.buttonBorder} onClick={() => {
        trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_BHET_DAAN_CARD + " " + WEB_ENGAGE.BUTTON_NAMES.ADD_BHET_DAAN + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
          [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_BHET_DAAN_CARD,
          [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.POSITIVE,
          [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: subEventDetails?.eventName_WE,
          [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: subEventDetails?.name_WE,
          [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: subEventDetails?.deityName,
          [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid,
          [WEB_ENGAGE.EVENT_PROPERTIES.SUB_EVENT_URL_EXTENSION]: subeventid
        });
        dispatch(addToCart(data));
      }}>
            <Typography className={classes.buttonText}>+ {t("add")}</Typography>
          </Stack> :
      // + X -
      <Box width={"100px"} height={"32px"} className={classes.buttonFilled}>
            <RemoveIcon sx={{
          color: "#fff",
          fontSize: "20px",
          cursor: "pointer"
        }} onClick={() => {
          dispatch(removeFromCart(data));
        }} />
            <Typography fontFamily={"Poppins"} fontSize={"15px"} color={"#ffffff"} fontWeight={"bold"} textAlign={"center"} justifyContent={"center"} sx={{
          mt: "1px"
        }}>
              {existInCart?.quantity ?? 0}
            </Typography>
            <AddIcon sx={{
          color: "#fff",
          fontSize: "20px",
          cursor: "pointer"
        }} onClick={() => {
          dispatch(addToCart(data));
        }} />
          </Box>}
      </div>
    </Box>;
}
export default PujaBhetCard;